import { render, staticRenderFns } from "./brandSafety.vue?vue&type=template&id=967fb19e&"
import script from "./brandSafety.vue?vue&type=script&lang=js&"
export * from "./brandSafety.vue?vue&type=script&lang=js&"
import style0 from "./brandSafety.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports